import { STARTUP_ROLES } from '../common_components/authorization/constants';

function getSteps(section, intl, user) {
  switch (section) {
    case 'affiliation':
      return [
        {
          content: intl.formatMessage({
            id: 'tooltips.affiliation.affiliation_form',
          }),
          target: '#affiliation-form',
          disableBeacon: true,
        },
        {
          content: intl.formatMessage({
            id: 'tooltips.affiliation.form_controls_email',
          }),
          target: '#form-control-email',
        },
        {
          content: intl.formatMessage({
            id: 'tooltips.affiliation.form_controls_select',
          }),
          target: '#formControlsSelect',
        },
        {
          content: intl.formatMessage({
            id: 'tooltips.affiliation.affiliation_table',
          }),
          target: '#affiliation-table',
        },
      ];
    case 'members':
      return [
        {
          content: intl.formatMessage({
            id: 'tooltips.members.intro',
          }),
          target: 'body',
          placement: 'center',
          disableBeacon: true,
        },
        {
          content: intl.formatMessage({
            id: 'tooltips.members.roles_stack',
          }),
          target: '#roles-stack',
        },
        ...[
          STARTUP_ROLES.CEO,
          STARTUP_ROLES.CO_FOUNDER,
          STARTUP_ROLES.STAFF,
          STARTUP_ROLES.INVESTOR,
          STARTUP_ROLES.FREELANCER,
          STARTUP_ROLES.MENTOR,
          STARTUP_ROLES.ADVISOR,
          STARTUP_ROLES.GUEST,
        ].map((t) => ({
          content: intl.formatMessage({ id: `tooltips.members.${t}_desc` }),
          target: `#circumstances-tab-${t}`,
        })),
        {
          content: intl.formatMessage({
            id: 'tooltips.members.send_invitations',
          }),
          target: '.bhoechie-tab .tab-pane.active.fade.in #send-invitations',
        },
        {
          content: intl.formatMessage({
            id: 'tooltips.members.users_list',
          }),
          target: '.bhoechie-tab .tab-pane.active.fade.in #users-list',
        },
      ];
    case 'boards':
      return [
        {
          content: intl.formatMessage({
            id: 'tooltips.boards.roles_stack',
          }),
          target: '#roles-stack',
          disableBeacon: true,
        },
        ...[
          STARTUP_ROLES.BOARD_OF_DIRECTOR,
          STARTUP_ROLES.ADVISORY_BOARD,
          STARTUP_ROLES.ADVISORY_SERVICE,
        ].map((t) => ({
          content: intl.formatMessage({ id: `tooltips.members.${t}_desc` }),
          target: `#circumstances-tab-${t}`,
        })),
        {
          content: intl.formatMessage({
            id: 'tooltips.boards.send_invitations',
          }),
          target: '.bhoechie-tab .tab-pane.active.fade.in #send-invitations',
        },
        {
          content: intl.formatMessage({
            id: 'tooltips.boards.users_list',
          }),
          target: '.bhoechie-tab .tab-pane.active.fade.in #users-list',
        },
      ];
    case 'unauthorized':
      return [
        {
          content: intl.formatMessage({ id: 'tooltips.unauthorized' }),
          target: 'body',
          placement: 'center',
          disableBeacon: true,
        },
      ];
    default:
      return [];
  }
}

const TOOLTIPPROPS = {
  getSteps,
  sections: { default: 'eeh' },
};

export { TOOLTIPPROPS };
